<template lang="pug">
  .ranking.flex.flex-col.justify-center
    .rank.flex.shadow.m-2.p-2.rounded(v-for="(rank, i) in ranking" :key="ranking._id")
      .position.text-xl.p-2 \#{{ ('' + (i + 1)) }}
      img.rounded-full.w-12.h-12(:src="rank.user.avatar")
      .text-left.px-4
        .name.text-lg.text-black.leading-none.mb-1.font-bold
          | {{ rank.user.alias }}
          |
        .inventory.flex
          Icon(size="sm" item="gold")
          .gold.text-sm.p-1 {{ rank.gold }}

</template>

<script>
import GameApi from '@/plugins/GameApi'

export default {
  name: 'Ranking',
  async mounted () {
    this.ranking = await GameApi.ranking()
  },
  data () {
    return {
      ranking: []
    }
  }
  // sockets: {
  //   connect () {
  //     console.log('connected')
  //   },
  //   ranking (users) {
  //     console.log(users, 'users')
  //     this.users = users
  //   }
  // }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/ranking.vue